export function logoSlider() {
    let $logoSlider = $(".logo-list");
    let $win = $(window);

    let initSlider = function () {
        $logoSlider.slick({
            arrows: false,
            dots: false,
            infinite: true,
            variableWidth: true,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 6000,
            responsive: [
                {
                    breakpoint: 744,
                    settings: "unslick",
                }
            ],
        });
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let $slider = $(entry.target);

            if ($slider.hasClass("slick-initialized")) {
                if (entry.isIntersecting) {
                    $slider.slick("slickPlay");
                } else {
                    $slider.slick("slickPause");
                }
            }
        });
    });

    $logoSlider.each(function () {
        observer.observe(this);
    });

    if ($logoSlider.find("li").length > 2 && $win.width() < 744) {
        initSlider();
    }

    $win.on("resize", function () {
        if ($win.width() < 744 && !$logoSlider.hasClass("slick-initialized")) {
            initSlider();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/logoSlider.js